import { useSelector } from "react-redux";
import {
  CampaignRecommendations,
  type SimilarSalesProps,
} from "~/features/saleRecommendations/components/CampaignRecommendations/CampaignRecommendations";
import type { RootState } from "~/app/store";
import { SearchPageType } from "~/features/search/models/SearchPageType";
import { useSearchPageType } from "~/features/search/context/SearchPageTypeContext";

export const SRPCampaignRecommendations = (props: Omit<SimilarSalesProps, "products" | "variant">) => {
  const products = useSelector((state: RootState) => {
    const productCodes = state.srp.productsOnSale.productsOnSale;
    return productCodes.map((code) => state.products.basic[code]);
  });

  const inFlight = useSelector((state: RootState) => state.srp.productsOnSale.productsOnSaleInFlight);

  const pageType = useSearchPageType();
  if (!(pageType === SearchPageType.SEARCH)) {
    return null;
  }

  if (products.length == 0) {
    return null;
  }

  return <CampaignRecommendations {...props} variant={"SRP"} products={products} loading={inFlight} />;
};
